var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":("lm-form-subtitles-builder-ui-" + _vm.id)}},[_c('LmSelect',{staticClass:"col-12 col-md-6",attrs:{"id":_vm.id + 'css',"options":{
      content: [
        {value: 'col-12 col-md-3',text: '25%'},
        {value: 'col-12 col-md-6', text: '50%'},
        {value: 'col-12 col-md-9', text: '75%'},
        {value: 'col-12 col-md-12', text: '100%'}
      ]
    },"label":"Ancho vista escritorio","help":_vm.$t('help_width_form_element')},on:{"input":function($event){return _vm.$emit('input', _vm.component)}},model:{value:(_vm.component.class),callback:function ($$v) {_vm.$set(_vm.component, "class", $$v)},expression:"component.class"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }